import React from "react";
import myPDF from '../assets/policyDoc.pdf';
export default function  PolicyDocumentComponent()  {
    return (<a href={myPDF} download="Policy Document.pdf"> Download Here </a>)
}